import { Currency } from '@/core/currency/interfaces';

const HUF: Currency = {
    name: 'Hungarian Forint',
    demonym: 'Hungarian',
    majorSingle: 'Forint',
    majorPlural: 'Forint',
    codeNumeric: '348',
    symbol: 'Ft',
    symbolNative: 'Ft',
    minorSingle: 'fillér',
    minorPlural: 'fillér',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'HUF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default HUF;
